// TODO: Remove from `core-js@4`
require('../modules/esnext.string.match-all');
